import { lazy } from "react";
import { withSuspense } from "../wrappers";

const Markdown = lazy(
  () => import(/* webpackChunkName: "markdown" */ "./MarkdownMain"),
);

export default withSuspense(Markdown, "Markdown");
